import { AxiosRequestConfig } from 'axios';

import Client from './client';

type Data = {
  labels: number[];
  talents: number[];
  travellingTypePreference?: 1 | 2;
};

type Response = {
  readonly result: 'SUCCESS' | 'FAIL';
  readonly status: number;
};

export default (data: Data, config?: AxiosRequestConfig) => {
  return Client.put<Response>('/um/v1/informations', data, config);
};
